import * as yup from 'yup';
import Validations from 'enums/schemaValidations/validations.enum';

const createAuditSchema = yup.object().shape({
  transactionId: yup.string().required(Validations.RequiredTransactionId),
  merchantName: yup.string().required(Validations.RequiredMerchantName),
  auditCode: yup
    .number()
    .transform((val) => (Number.isNaN(val) ? undefined : val))
    .required(Validations.RequiredAuditCode),
  auditDescription: yup
    .string()
    .max(500, 'Must be less than 500 Characters')
    .required(Validations.RequiredAuditDescription),
  issuer: yup.string().required(Validations.RequiredIssuer).nullable(),
  preferredContactEmail: yup
    .string()
    .email(Validations.PreferredContactEmailInvalid),
});

export { createAuditSchema };
